import FirmApi from '../../services/FirmApi'
import Firm from '../../models/firmClass'

export const claim = {
    namespaced: true,
    state: {
        firm: Firm,
        id_firmy: 0,
        majitel_firmy: null,
    },
    mutations: {
        setIdFirmy(state, id_firmy) {
            state.id_firmy = id_firmy
        },
        setFirm(state, firm) {
            state.firm = firm
        },
        setMajitelFirmy(state, majitel_firmy) {
            state.majitel_firmy = majitel_firmy
        },
    },
    actions: {
        fetchDetail({ commit, dispatch }, id_firmy) {
            dispatch('loader/setLoader', 'Načítám detail firmy ...', {
                root: true,
            })

            FirmApi.fetchDetail(id_firmy)
                .then(function(response) {
                    // console.log('fetchDetail', response)
                    const { status, results } = response.data
                    if (status == true) {
                        commit('setFirm', new Firm(results))
                        dispatch('loader/setLoader', '', { root: true })
                    }
                })
                .catch(function(error) {
                    console.log(error)
                    dispatch('loader/setError', error, { root: true })
                })
        },
        fetchMajitelFirmy({ commit, dispatch }, id_firmy) {
            dispatch('loader/setLoader', 'Načítám vlastníka firmy ...', {
                root: true,
            })
            FirmApi.fetchMajitelFirmy(id_firmy)
                .then(function(response) {
                    const { status, results } = response.data
                    if (status == true) {
                        commit('setMajitelFirmy', results)
                        dispatch('loader/setLoader', '', { root: true })
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
    },
}
